import React from "react";
import {CustomCloseModalIcon} from "./icons/custom-close-modal-icon";
import marketBook from "../../img/market-book.png";
import {Grid} from "@mui/material";
import styled from "styled-components";
import {Colors} from "../../theme/colors";
import {StyledButton} from "./button";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const NotAccessModal: React.FC<{open: boolean, setOpen?: Function}> = ({open, setOpen, children}) => {
    const history = useHistory();
    const { t } = useTranslation('common');

    const buttonNavigate = () => {
        history.push('/publisher/price-list');
        if (setOpen) {
            setOpen(false);
        }
    }


    const MailtoButton = ({ email }) => {
        const mailtoLink = `mailto:${email}`;

        const styles = {
            button: {
                display: 'inline-block',
                padding: '10px 20px',
                backgroundColor: '#FFC160',
                color: '#1A082B',
                textDecoration: 'none',
                borderRadius: '5px',
                transition: 'background-color 0.3s ease',
                cursor: 'pointer',
            }
        };

        return (
            <a href={mailtoLink} style={styles.button}>
                {email}
            </a>
        );
    };

    return (
        <>
        {open &&
        <StyledBlockedContent container direction={"column"} justifyContent={"center"} alignContent={"center"}>
            <StyledBlockedInfo item container direction={"column"} alignItems={"center"}>
                {setOpen &&
                <StyledCloseButton onClick={() => {
                    setOpen(false);
                }}><CustomCloseModalIcon/></StyledCloseButton>
                }

                <StyledBlockedImgContainer item>
                    <img src={marketBook} alt={'book'}/>
                </StyledBlockedImgContainer>

                <Grid item>
                    <StyledBlockedTitle>{t('notAccessModal.text')}</StyledBlockedTitle>
                </Grid>

                <Grid item>
                    <MailtoButton email="info@bookscout.ai" />
                </Grid>
            </StyledBlockedInfo>
        </StyledBlockedContent>
        }
        </>
    );
}

const StyledBlockedContent = styled(Grid)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.8561799719887955);
  z-index: 1111111;
`;

const StyledBlockedInfo = styled(Grid)`
  background: #FBF5FF;
  border: 1px solid ${Colors.lightViolet};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  max-width: 400px !important;
  position: relative;
  padding-bottom: 1rem;
  
  & > div {
    padding-top: 1rem;
  }
`;

const StyledBlockedImgContainer = styled(Grid)`
  margin-top: -55px;
`;

const StyledBlockedTitle = styled('h6')`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${Colors.lightViolet};
  text-align: center;
`;

const StyledCloseButton = styled('div')`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  padding-top: 0 !important;
`;
